(function () {
  function cleanWords(str) {
    return (str || "").trim().replace(/\s+/g, " ");
  }

  function countWords(str) {
    const cleaned = cleanWords(str);
    if (!cleaned) return 0;
    return cleaned.split(" ").length;
  }

  function initGiftBlock(root) {
    const enable = root.querySelector(".mb-gift-enable");
    const panel = root.querySelector(".mb-gift-panel");
    const wrap = root.querySelector(".mb-box-fields");
    const genErr = root.querySelector(".mb-general-error");

    const genericImg = root.dataset.genericImg || "";
    const valentinesImg = root.dataset.valentinesImg || "";

    const form =
      document.getElementById(root.dataset.productFormId) ||
      root.closest(".product-text")?.querySelector('form[data-type="add-to-cart-form"]');

    if (!form) return;

    const variantInput = form.querySelector('input[name="id"]');
    const qtyInput = form.querySelector('input[name="quantity"]');

    function getQty() {
      const q = qtyInput ? parseInt(qtyInput.value || "1", 10) : 1;
      return isNaN(q) || q < 1 ? 1 : q;
    }

    function buildBoxes() {
      const qty = getQty();
      wrap.innerHTML = "";

      for (let i = 1; i <= qty; i++) {
        const gImg = genericImg
          ? `<img src="${genericImg}" alt="Generic card">`
          : `<div>Generic</div>`;

        const vImg = valentinesImg
          ? `<img src="${valentinesImg}" alt="Valentines card">`
          : `<div>Valentines</div>`;

        const box = document.createElement("div");
        box.className = "mb-box-block";
        box.innerHTML = `
          <strong>Gift Card for Box ${i}</strong>

          <div class="mb-card-grid">
            <label class="mb-card-tile">
              <input type="radio" name="mb_card_${i}" value="Generic" hidden>
              <div class="mb-card-inner">${gImg}<div class="mb-card-name">Generic</div></div>
            </label>

            <label class="mb-card-tile">
              <input type="radio" name="mb_card_${i}" value="Valentines" hidden>
              <div class="mb-card-inner">${vImg}<div class="mb-card-name">Valentines</div></div>
            </label>
          </div>

          <div class="mb-card-error" hidden>Please choose a card design.</div>

          <textarea rows="3" placeholder="Write your message (max 30 words)"
            style="width:100%;margin-top:10px;padding:10px;border-radius:10px;border:1px solid rgba(0,0,0,.2);"></textarea>

          <div style="display:flex;justify-content:space-between;font-size:12px;margin-top:6px;">
            <span class="wc">30 words remaining</span>
            <span class="mb-msg-error" hidden>Too many words</span>
          </div>
        `;

        wrap.appendChild(box);

        const tiles = box.querySelectorAll(".mb-card-tile");
        const radios = box.querySelectorAll('input[type="radio"]');

        tiles.forEach((tile, idx) => {
          tile.addEventListener("click", () => {
            radios[idx].checked = true;
            tiles.forEach((t) => t.classList.remove("is-active"));
            tile.classList.add("is-active");
            box.querySelector(".mb-card-error").hidden = true;
          });
        });

        const ta = box.querySelector("textarea");
        const wc = box.querySelector(".wc");
        const msgErr = box.querySelector(".mb-msg-error");

        ta.addEventListener("input", () => {
          const words = countWords(ta.value);
          wc.textContent = `${30 - words} words remaining`;
          msgErr.hidden = !(words > 30);
        });
      }
    }

    enable.addEventListener("change", () => {
      panel.hidden = !enable.checked;
      genErr.hidden = true;
      if (enable.checked) buildBoxes();
      else wrap.innerHTML = "";
    });

    if (qtyInput) {
      qtyInput.addEventListener("change", () => enable.checked && buildBoxes());
      qtyInput.addEventListener("input", () => enable.checked && buildBoxes());
    }

    async function addOne(variantId, props) {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          properties: props
        })
      });

      if (!res.ok) throw new Error("Gift message add failed");
    }

    form.addEventListener("submit", async (e) => {
      if (!enable.checked) return;

      e.preventDefault();

      const variantId = variantInput?.value;
      if (!variantId) return;

      const qty = getQty();
      let hasError = false;

      for (let i = 1; i <= qty; i++) {
        const box = wrap.children[i - 1];
        const design = box.querySelector('input[type="radio"]:checked')?.value;
        const msg = cleanWords(box.querySelector("textarea").value);

        box.querySelector(".mb-card-error").hidden = !!design;
        box.querySelector(".mb-msg-error").hidden = !(countWords(msg) > 30);

        if (!design || countWords(msg) > 30) hasError = true;
      }

      if (hasError) {
        genErr.hidden = false;
        return;
      }

      for (let i = 1; i <= qty; i++) {
        const box = wrap.children[i - 1];

        await addOne(variantId, {
          "Card design": box.querySelector('input[type="radio"]:checked').value,
          "Gift message": cleanWords(box.querySelector("textarea").value),
          "Box": String(i)
        });
      }

      window.location.href = "/cart";
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-mb-gift-block]").forEach(initGiftBlock);
  });
})();